import AssignmentIcon from '@mui/icons-material/Assignment'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import ListSubheader from '@mui/material/ListSubheader'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { Link } from '../../router/components/Link'

interface Props {
  onItemClick?: () => void
}

export const HoofdnetMenu = ({ onItemClick }: Props) => {
  const { canViewHoofdnetOpdrachten } = useAuthenticatedUser()

  const shouldRender = canViewHoofdnetOpdrachten

  return shouldRender ? (
    <>
      <List subheader={<ListSubheader>Hoofdnet</ListSubheader>}>
        {canViewHoofdnetOpdrachten && (
          <ListItemButton
            component={Link}
            onClick={onItemClick}
            to="/hoofdnetopdrachten"
          >
            <ListItemIcon sx={{ color: 'black' }}>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Opdrachten" />
          </ListItemButton>
        )}
      </List>

      <Divider />
    </>
  ) : null
}
